import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  PriceLabel: {
    '&>h3': {
      fontSize: '1.75em',
      fontWeight: type.fontWeight.medium,
      whiteSpace: 'nowrap',
    },
    '&>span': {
      textDecoration: 'line-through ',
      fontWeight: type.fontWeight.light,
      color: pricingPalette.colors.stone,
      lineHeight: 1,
      '&>span': {
        color: pricingPalette.colors.stone,
      },
    },
  },
  Price: {
    marginRight: spacing[1],
  },
  SwissPriceUnit: {
    [MD_MEDIA_QUERY]: {
      '& span': {
        fontSize: type.fontSize.bodySm,
      },
    },
  },
}));
